import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

//Servicios
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoServicio}</td>
      <td className=''>{elemento.nombreResumido}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.subclaseserv.claseserv.codigoClaseServ}</td>
      <td className=''>{elemento.subclaseserv.claseserv.descrClaseServ}</td>
      <td className=''>{elemento.subclaseserv.codigoSubclaseServ}</td>
      <td className=''>{elemento.subclaseserv.descrSubclaseServ}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
)
};

const ConfServ2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Servicios" btnNuevo={a250110!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '10%'}}>Código</th>
                <th className='' style={{width: '20%'}}>Nombre resumido</th>
                <th className='' style={{width: '30%'}}>Descripción</th>
                <th className='' style={{width: '5%'}}>Cód clase</th>
                <th className='' style={{width: '15%'}}>Clase</th>
                <th className='' style={{width: '5%'}}>Cód subclase</th>
                <th className='' style={{width: '15%'}}>Subclase</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

// export default graphql(queries.query.allServicios)(ConfServ2)
export default ConfServ2
